// utils/pwaInstall.js
//
// beforeinstallprompt fires once per session, early in page load. In an SPA,
// a component's useEffect only runs once the user navigates to that route —
// if the event already fired before that (e.g. user landed on /login first,
// then clicked through to /installation via client-side routing), it's
// missed for good until a real page reload. This module attaches the
// listener immediately at import time, so it catches the event no matter
// which route happens to be active when it fires.

let deferredPromptEvent = null;
let alreadyInstalled = false;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPromptEvent = e;
    listeners.forEach((cb) => cb({ type: "available", event: e }));
  });

  window.addEventListener("appinstalled", () => {
    deferredPromptEvent = null;
    alreadyInstalled = true;
    listeners.forEach((cb) => cb({ type: "installed" }));
  });
}

export function getDeferredPrompt() {
  return deferredPromptEvent;
}

export function wasInstalledThisSession() {
  return alreadyInstalled;
}

export function clearDeferredPrompt() {
  deferredPromptEvent = null;
}

// Subscribe to future events; also fires immediately if state already exists,
// so a late-mounting component doesn't miss a prompt that arrived earlier.
export function subscribe(callback) {
  listeners.add(callback);

  if (deferredPromptEvent) {
    callback({ type: "available", event: deferredPromptEvent });
  } else if (alreadyInstalled) {
    callback({ type: "installed" });
  }

  return () => listeners.delete(callback);
}